import { render, staticRenderFns } from "./SplashContainer.vue?vue&type=template&id=ec9b1b86&scoped=true"
import script from "./SplashContainer.vue?vue&type=script&lang=js"
export * from "./SplashContainer.vue?vue&type=script&lang=js"
import style0 from "./SplashContainer.vue?vue&type=style&index=0&id=ec9b1b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9b1b86",
  null
  
)

export default component.exports